import { render, staticRenderFns } from "./Zdgl.vue?vue&type=template&id=dcae136a&scoped=true&"
import script from "./Zdgl.vue?vue&type=script&lang=js&"
export * from "./Zdgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcae136a",
  null
  
)

export default component.exports